import React from "react";
import styled from "styled-components";
import Header from "../styles/Header";
import { motion } from "framer-motion";
import SubscriptionDetail from "./SubscriptionDetail";
import ProfileInfo from "../components/ProfileInfo";

export default function Profile() {
  return (
    <>
      <Header
        title="Your Profile"
        description="Manage your account settings and view your subscription details"
      />
      <StyledProfile>
        <motion.div
          className="profile-container"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <ProfileContent>
            <ProfileInfo />
            <Divider />
              <SubscriptionDetail />
          </ProfileContent>
        </motion.div>
      </StyledProfile>
    </>
  );
}

const StyledProfile = styled.div`
  width: var(--section-width);
  margin: var(--section-margin) auto;
  padding: 2rem;

  .profile-container {
    background: transparent;
    border-radius: 16px;
    padding: 0;
    display: flex;
    align-items: stretch;
    justify-content: center;
    flex-direction: column;
  }

  .profile-header {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 3rem;
    padding-bottom: 2rem;
    border-bottom: 1px solid #eee;

    .logout-btn {
      background-color: #ff4444;
      color: white;
      border: none;
      padding: 0.5rem 1.5rem;
      border-radius: 8px;
      cursor: pointer;
      font-weight: 500;
      transition: background-color 0.3s ease;

      &:hover {
        background-color: #ff0000;
      }
    }
  }

  .profile-sections {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }

  .profile-section {
    h3 {
      font-size: 1.4rem;
      color: #333;
      margin-bottom: 1.5rem;
    }

    .section-content {
      background: #f8f8f8;
      border-radius: 12px;
      padding: 1.5rem;
    }
  }

  .setting-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 0;
    border-bottom: 1px solid #eee;

    &:last-child {
      border-bottom: none;
    }

    .toggle-btn {
      padding: 0.5rem 1rem;
      border-radius: 20px;
      border: 1px solid #ddd;
      background: white;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        background: #f0f0f0;
      }
    }
  }

  .subscription-info {
    p {
      margin-bottom: 1rem;
      color: #666;

      span {
        color: #333;
        font-weight: 500;
      }
    }
  }

  .history-item {
    padding: 1rem 0;
    border-bottom: 1px solid #eee;

    &:last-child {
      border-bottom: none;
    }

    p {
      font-weight: 500;
      margin-bottom: 0.5rem;
    }

    span {
      color: #666;
      font-size: 0.9rem;
    }
  }

  @media (max-width: 768px) {
    padding: 1rem;

    .profile-container {
      padding: 0;
    }

    .profile-header {
      flex-direction: column;
      text-align: center;
      gap: 1rem;
    }
  }
`;

const ProfileContent = styled.div`
  display: flex;
  gap: 4rem;
  align-items: center;
  justify-content: center;
  width: 100%;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
    gap: 2rem;
  }
`;

const Divider = styled.div`
  width: 1px;
  background: linear-gradient(
    to bottom,
    transparent 0%,
    #e0e0e0 20%,
    #e0e0e0 80%,
    transparent 100%
  );
  min-height: 400px;
  align-self: stretch;

  @media (max-width: 1024px) {
    width: 100%;
    height: 1px;
    min-height: 1px;
    background: linear-gradient(
      to right,
      transparent 0%,
      #e0e0e0 20%,
      #e0e0e0 80%,
      transparent 100%
    );
    align-self: auto;
  }
`;

const SubscriptionSection = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  max-width: 500px;
`;
